module.exports = __webpack_public_path__ + "img/8.b5d62c9d.jpg";